import React from 'react';
import {
  Box,
  ToggleButtonGroup,
  ToggleButton,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  GridView as GridViewIcon,
  ViewList as ViewListIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
} from '@mui/icons-material';

const ViewModeToggle = ({ viewMode, onViewModeChange, gridSize, onGridSizeChange }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <ToggleButtonGroup
        value={viewMode}
        exclusive
        onChange={(e, newMode) => {
          if (newMode !== null) {
            onViewModeChange(newMode);
          }
        }}
        aria-label="view mode"
        sx={{ mb: 2 }}
      >
        <ToggleButton value="grid" aria-label="grid view">
          <GridViewIcon />
        </ToggleButton>
        <ToggleButton value="list" aria-label="list view">
          <ViewListIcon />
        </ToggleButton>
      </ToggleButtonGroup>

      {viewMode === 'grid' && (
        <>
          <Tooltip title="Smaller grid">
            <IconButton
              size="small"
              onClick={() => onGridSizeChange('small')}
              color={gridSize === 'small' ? 'primary' : 'default'}
            >
              <ZoomOutIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Larger grid">
            <IconButton
              size="small"
              onClick={() => onGridSizeChange('large')}
              color={gridSize === 'large' ? 'primary' : 'default'}
            >
              <ZoomInIcon />
            </IconButton>
          </Tooltip>
        </>
      )}
    </Box>
  );
};

export default ViewModeToggle; 